import {
  computed,
  useBlokkli,
  onMounted,
  onUnmounted,
  provide
} from "#imports";
import { settingsOverride } from "#blokkli-build/config";
import { INJECT_EDIT_LOGGER } from "#blokkli/helpers/symbols";
export function defineBlokkliFeature(feature) {
  const { adapter, storage, features, debug } = useBlokkli();
  const logger = debug.createLogger(feature.label || feature.id);
  const storageKey = computed(() => `feature:${feature.id}:settings`);
  const defaults = Object.entries(feature.settings || {}).reduce((acc, [key, config]) => {
    const overrideKey = `feature:${feature.id}:${key}`;
    const override = settingsOverride[overrideKey];
    if (override && "default" in override && override.default !== void 0) {
      acc[key] = override.default;
    } else if ("default" in config) {
      acc[key] = config.default;
    }
    return acc;
  }, {});
  const settingsStorage = storage.use(storageKey, defaults);
  const settingsEnforced = computed(
    () => Object.keys(feature.settings || {}).reduce(
      (acc, key) => {
        const overrideKey = `feature:${feature.id}:${key}`;
        const override = settingsOverride[overrideKey];
        if (override?.disable) {
          acc[key] = defaults[key];
        }
        return acc;
      },
      {}
    )
  );
  const settings = computed(() => {
    return {
      // Default settings defined by the feature.
      ...defaults,
      // Settings altered by the user.
      ...settingsStorage.value,
      // Settings always enforced via config.
      ...settingsEnforced.value
    };
  });
  onMounted(() => {
    features.mount(feature);
    logger.log("Feature mounted");
  });
  onUnmounted(() => {
    features.unmount(feature.id);
    logger.log("Feature unmounted");
  });
  provide(INJECT_EDIT_LOGGER, logger);
  return {
    adapter,
    settings,
    logger
  };
}
